import React from 'react';
import { useTranslation } from 'react-i18next';
import { Checkbox, Button } from '@pwc/pwc-deals-ui';
import './ConnectContentModal.scss';

const ConnectContentModal = ({
  onModalDismiss,
  onModalConfirm,
  modalTitle,
  modalBody,
  modalCheckboxLabel,
  modalCheckboxValue = false,
  hideCheckbox = false,
  hideConfirm = false,
  onChange,
  dataTestId,
}) => {
  const { t } = useTranslation();
  return (
    <div className="modal-popover__content" data-testid={dataTestId}>
      <div className="modal-popover__title">{modalTitle}</div>
      <div className="modal-popover__body">{modalBody}</div>
      {!hideCheckbox && (
        <div className="modal-popover__checkbox">
          <Checkbox
            id="connected-connect-card-modal-checkbox"
            label={modalCheckboxLabel}
            selected={modalCheckboxValue}
            onChange={onChange}
          />
        </div>
      )}
      <div className="modal-popover__actions">
        <Button
          type="button"
          className="button-outline button-small mr-4"
          data-testid="btn-modal-cancel"
          onClick={onModalDismiss}
        >
          {hideConfirm ? t('btnClose') : t('btnCancel')}
        </Button>
        {!hideConfirm && (
          <Button
            type="button"
            className="button-block button-small"
            data-testid="btn-modal-confirm"
            onClick={onModalConfirm}
          >
            {t('yesConnect')}
          </Button>
        )}
      </div>
    </div>
  );
};

export default ConnectContentModal;
